import Amount from "@/models/Shared/Amount";
import FeeState from "@/models/Accounts/Shared/Fees/FeeState";

export default class Fee {
    id: string;
    accountId: string;
    amount: Amount;
    description: string;
    subTransactionType: string;
    queueOnFailure: boolean;
    status: FeeState;
    createdAt: Date;
    updatedAt: Date;
}